import type { TTexture } from '@seddi/surface-material';
import type { LoadingManager, Texture, WebGLRenderer } from '@seddi/three';
import log from 'loglevel';

import { ResourceManager } from './resourceManager';
import { load } from './textureLoader';

export class TexturesContext extends ResourceManager<Texture> {
  readonly manager: LoadingManager;
  readonly renderer: WebGLRenderer;

  constructor(manager: LoadingManager, renderer: WebGLRenderer) {
    super();
    this.manager = manager;
    this.renderer = renderer;
  }

  async loadAsync(desc: TTexture): Promise<string | undefined> {
    if (this.find(desc.id)) {
      log.warn(`TexturesContext.loadAsync: ${desc.id} is not new.`);
      return desc.id;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const texture = await load(desc, this.manager, this.renderer);
    item.value = texture;
    item.status = 'ready';

    if (this.onLoad) {
      this.onLoad(desc.id, 'Texture');
    }

    return desc.id;
  }
}
